import React, { useEffect, useState } from "react";
import OurLayouts from "../layout";
import Ambulanceicon from "../../assets/Ambulanceicon.svg";
import { Pagination } from "antd";
import axios from "axios";
import { format } from "date-fns";
import { toast } from "react-toastify";
import nodata from "../../assets/nodata.svg";
import OrderDetailsModal, {
  OrderDetailsSection,
} from "../shared/OrderDetailsModal";
import { AmbulanceTrackingTimeline } from "./AmbulanceOrders";
import TrackEnquiry from "./TrackEnquiry";

const COMMAND_CENTER_URL = process.env.REACT_APP_API_COMMAND_CENTER_URL;

const ClinicAmbulanceDetails = () => {
  const [orders, setOrders] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [filters, setFilters] = useState({
    orderId: "",
    fromDate: format(new Date(), "yyyy-MM-dd"),
    toDate: format(new Date(), "yyyy-MM-dd"),
  });

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(10);
  const [totalElements, setTotalElements] = useState(0);

  const [loadingTracking, setLoadingTracking] = useState(false);
  const [orderTracking, setOrderTracking] = useState(null);
  const [isOrderTrackingVisible, setIsOrderTrackingVisible] = useState(false);

  const [ticketdata, setTicketdata] = useState();
  const [isModalVisible2, setIsModalVisible2] = useState(false);

  const API_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    fetchOrders();
  }, [filters]);

  async function fetchOrders(page = currentPage) {
    const token = localStorage.getItem("auth_token");
    const tenantId = localStorage.getItem("tenantId");
    const clinicId = localStorage.getItem("clinicId");
    try {
      const resp = await axios.get(
        `${API_URL}orders/get-all?serviceType=AMBULANCE&clinicId=${clinicId}` +
          `&fromDate=${filters.fromDate}` +
          `&toDate=${filters.toDate}` +
          (filters.orderId ? `&id=${filters.orderId}` : "") +
          `&page=${page - 1}&size=${pageSize}`,
        {
          headers: {
            Accept: "*/*",
            Authorization: `Bearer ${token}`,
            tenantId: tenantId,
          },
        }
      );
      const records = resp.data?.records || resp.data?.data?.content || [];
      setOrders(records);
      setTotalElements(
        resp.data?.totalElements || resp.data?.data?.totalElements || 0
      );
      setCurrentPage(page);
    } catch (err) {
      console.error("Fetch error:", err.response || err);
    }
  }

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSearch = () => {
    fetchOrders(1);
  };

  const handleReset = () => {
    setFilters({
      orderId: "",
      fromDate: format(new Date(), "yyyy-MM-dd"),
      toDate: format(new Date(), "yyyy-MM-dd"),
    });
    fetchOrders(1);
  };

  const handlePageChange = (page) => {
    fetchOrders(page);
  };

  const handleViewDetails = (order) => {
    setSelectedOrder(order);
    setIsModalVisible(true);
  };

  const handleTrackOrderCommandCenter = async (order) => {
    const ticketId = order?.enquiryTickets?.[0]?.ticketId;
    const hospitalId = localStorage.getItem("hospitalid") || "";
    if (!ticketId) {
      toast.info("No tracking ticket available for this order.");
      return;
    }
    setLoadingTracking(true);
    try {
      const response = await fetch(
        `${COMMAND_CENTER_URL}ambulance/tracking?hospitalId=${encodeURIComponent(
          hospitalId
        )}&ticketId=${ticketId}`,
        {
          method: "GET",
          headers: {
            accept: "application/json",
          },
        }
      );
      const data = await response.json();
      const list = Array.isArray(data?.data)
        ? data.data
        : data?.data
        ? [data.data]
        : [];
      const booking =
        list.find((b) => String(b.ticketId) === String(ticketId)) ||
        list[0] ||
        null;
      if (booking) {
        setOrderTracking(booking);
        setIsOrderTrackingVisible(true);
      } else {
        toast.info("No tracking updates found.");
      }
    } catch (err) {
      console.error("Track order error:", err);
      toast.error("Failed to fetch tracking information.");
    } finally {
      setLoadingTracking(false);
    }
  };

  const handleTrackEnquiry = async (order) => {
    const ticketId = order?.enquiryTickets?.[0]?.ticketId;
    if (!ticketId) {
      toast.info("No enquiry ticket available for this order.");
      return;
    }
    try {
      const response = await fetch(
        `${COMMAND_CENTER_URL}patient/ticket/${ticketId}`,
        {
          method: "GET",
          headers: {
            accept: "application/json",
          },
        }
      );
      const ticketData = await response.json();
      setTicketdata(ticketData.data);
      setIsModalVisible2(true);
    } catch (err) {
      console.error("Track enquiry error:", err);
      toast.error("Failed to fetch enquiry details.");
    }
  };

  const getStatus = (order) => order?.enquiryTickets?.[0]?.ticketStatus || "";

  const AmbulanceCard = ({ order }) => (
    <div className="relative bg-white rounded-lg p-4 shadow-sm border w-full">
      <div className="flex items-start gap-4">
        <div className="w-10 h-10 mt-1 bg-gradient-to-br from-[#FF6B6B] to-[#C62828] rounded-full flex items-center justify-center flex-shrink-0">
          <img
            src={Ambulanceicon}
            alt="Ambulance Icon"
            className="w-6 h-6 object-contain"
          />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-md font-semibold text-[#003F6B] mb-1">
            <span className="text-green-600">{order?.patientName || "—"}</span>
          </p>
          <p className="text-sm text-gray-700 mt-1 mb-1 break-all">
            Id: {order.id}
          </p>
          {order.createdDate && (
            <p className="text-sm text-gray-700 mb-1">
              Placed On: {order.createdDate?.split("T")[0]}
            </p>
          )}
          {order.patientMobileNo && (
            <p className="text-sm text-gray-700 mb-1">
              Mobile: {order.patientMobileNo}
            </p>
          )}
          {getStatus(order) && (
            <span className="inline-block mt-1 px-2 py-0.5 rounded-full text-xs font-semibold bg-blue-100 text-blue-800 border border-blue-200">
              {getStatus(order)}
            </span>
          )}
        </div>
      </div>

      <div className="mt-4 flex flex-wrap justify-center gap-2">
        <button
          className="border border-[#003F6B] hover:bg-[#003F6B] hover:text-white text-[#003F6B] px-3 py-1.5 rounded text-xs font-medium transition-colors duration-200"
          onClick={() => handleViewDetails(order)}
        >
          View Details
        </button>
        <button
          className="border border-[#003F6B] hover:bg-[#003F6B] hover:text-white text-[#003F6B] px-3 py-1.5 rounded text-xs font-medium transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
          onClick={() => handleTrackOrderCommandCenter(order)}
          disabled={loadingTracking}
        >
          {loadingTracking ? "Loading..." : "Track Order"}
        </button>
        {order.enquiryTickets && order.enquiryTickets.length > 0 && (
          <button
            className="border border-[#00B77E] hover:bg-[#00B77E] hover:text-white text-[#00B77E] px-3 py-1.5 rounded text-xs font-medium transition-colors duration-200"
            onClick={() => handleTrackEnquiry(order)}
          >
            Track Enquiry
          </button>
        )}
      </div>
    </div>
  );

  return (
    <OurLayouts>
      <div className="min-h-screen p-4 bg-[#f1f8f7] rounded-lg">
        <div className="max-w-6xl mx-auto">
          <div className="bg-[#F0F9FB] min-h-screen rounded-lg">
            <div className="flex items-center justify-between mb-3">
              <h2 className="text-xl font-semibold text-[#003F6B]">
                Ambulance Enquiries
              </h2>
            </div>

            {/* Filter Form */}
            <div className="rounded-lg shadow-sm mb-6">
              <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Order ID
                  </label>
                  <input
                    type="text"
                    name="orderId"
                    value={filters.orderId}
                    onChange={handleFilterChange}
                    className="w-full p-2 border border-gray-300 rounded-md"
                    placeholder="Enter Order ID"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    From Date
                  </label>
                  <input
                    type="date"
                    name="fromDate"
                    value={filters.fromDate}
                    onChange={handleFilterChange}
                    className="w-full p-2 border border-gray-300 rounded-md"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    To Date
                  </label>
                  <input
                    type="date"
                    name="toDate"
                    value={filters.toDate}
                    onChange={handleFilterChange}
                    className="w-full p-2 border border-gray-300 rounded-md"
                  />
                </div>
                <div className="flex items-end space-x-2">
                  <button
                    onClick={handleSearch}
                    className="bg-[#003F6B] text-white px-4 py-2 rounded-md text-sm font-medium"
                  >
                    Search
                  </button>
                  <button
                    onClick={handleReset}
                    className="border border-[#003F6B] text-[#003F6B] px-4 py-2 rounded-md text-sm font-medium"
                  >
                    Reset
                  </button>
                </div>
              </div>
            </div>

            {orders.length > 0 ? (
              <>
                <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
                  {orders.map((order, index) => (
                    <AmbulanceCard key={order.id || index} order={order} />
                  ))}
                </div>

                {/* Pagination */}
                <div className="flex justify-center mt-6">
                  <Pagination
                    current={currentPage}
                    pageSize={pageSize}
                    total={totalElements}
                    onChange={handlePageChange}
                    showSizeChanger={false}
                  />
                </div>
              </>
            ) : (
              <div className="flex flex-col items-center justify-center h-full text-gray-500">
                <img src={nodata} alt="No Data" className="w-64 h-64 mb-4" />
                <div className="text-center text-gray-600">
                  No orders found for the selected filters.
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {isModalVisible && selectedOrder && (
        <OrderDetailsModal
          open={isModalVisible}
          onClose={() => setIsModalVisible(false)}
          subtitle="Ambulance Order Details"
          patientName={selectedOrder.patientName}
          status={getStatus(selectedOrder)}
          address={selectedOrder.address}
          addressLabel="Pickup Address"
          showAddress={Boolean(selectedOrder.address)}
          infoFields={[
            { label: "Order ID", value: selectedOrder.id, mono: true },
            {
              label: "Placed On",
              value: selectedOrder.createdDate?.split("T")[0],
            },
            { label: "Mobile No", value: selectedOrder.patientMobileNo },
            { label: "Patient Id", value: selectedOrder.patientId },
            { label: "Service Type", value: selectedOrder.serviceType },
            { label: "Reason", value: selectedOrder.ambulaceRequestReason },
          ]}
        />
      )}

      {isOrderTrackingVisible && orderTracking && (
        <OrderDetailsModal
          open={isOrderTrackingVisible}
          onClose={() => setIsOrderTrackingVisible(false)}
          subtitle="Ambulance Tracking"
          patientName={orderTracking.patientName}
         
          address={orderTracking.pickupAddress}
          addressLabel="Pickup Address"
          showAddress={Boolean(orderTracking.pickupAddress)}
          infoFields={[
            { label: "Ticket ID", value: orderTracking.ticketId, mono: true },
            { label: "Order ID", value: orderTracking.orderId },
            { label: "Booking Time", value: orderTracking.bookingTime },
            { label: "Mobile No", value: orderTracking.patientMobile },
            { label: "Booking Status", value: orderTracking.bookingStatus },
            // { label: "Reason", value: orderTracking.ambulaceRequestReason },
           
            { label: "Ambulance Reg No", value: orderTracking.ambulanceRegNo },
            { label: "Driver Name", value: orderTracking.driverName },
            { label: "Driver Number", value: orderTracking.driverNumber },
          ]}
        >
          {orderTracking.dropAddress && (
            <div className="rounded-xl border border-[#C5E8E3] bg-gradient-to-r from-[#E8F6F4] to-white px-4 py-4">
              <p className="text-[11px] font-medium uppercase tracking-wide text-[#0D6B6E] mb-1">
                Drop Address
              </p>
              <p className="text-sm font-medium text-slate-800 mb-0 leading-relaxed break-words">
                {orderTracking.dropAddress}
              </p>
            </div>
          )}

          <OrderDetailsSection title="Tracking History">
            <AmbulanceTrackingTimeline
              events={orderTracking.trackingEvents || []}
            />
          </OrderDetailsSection>
        </OrderDetailsModal>
      )}

      {isModalVisible2 && ticketdata && (
        <TrackEnquiry
          isModalVisible2={isModalVisible2}
          setIsModalVisible2={setIsModalVisible2}
          ticketdata={ticketdata}
        />
      )}
    </OurLayouts>
  );
};

export default ClinicAmbulanceDetails;
